'use client';

import { useAppTranslation } from 'app/hooks';
import { StakingStatus, UserStakingResponse } from 'models/stake';
import { formatAmountV2 } from 'utils/formatAmount';
import { formatDateNoTime } from 'utils/dateUtils';
import { Modal, Tooltip } from 'antd';
import { FaEye, FaTimes } from 'react-icons/fa';
import CloseIcon from 'assets/icons/CloseIcon';
import useThemes from 'hooks/useThemes';

interface ClaimHistoryModalProps {
  item: UserStakingResponse;
  visible: boolean;
  onCancel?: () => void;
}

const ClaimHistoryModal: React.FunctionComponent<ClaimHistoryModalProps> = ({
  visible,
  item,
  onCancel,
}) => {
  const t = useAppTranslation();
  const { currentTheme } = useThemes();

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      maskClosable={false}
      closeIcon={<CloseIcon isDarkMode={currentTheme === 'dark'} width="20" height="20" />}
      className="common-modal"
    >
      <div className="transaction staking-history-item">
        <div className="row">
          <span className="font-bold">{t('staking-history.header.id')}</span>
          <span>{item.id}</span>
        </div>
        <div className="row">
          <span className="font-bold">{t('staking-history.header.vault-name')}</span>
          <span>{item.stakingVaultDto.label}</span>
        </div>
        <div className="row">
          <span className="font-bold">{t('staking-history.header.day-number')}</span>
          <span>{item.stakingVaultDto.dayNumber}</span>
        </div>
        <div className="row">
          <span className="font-bold">{t('staking-history.header.reward-percent')}</span>
          <span>{item.stakingVaultDto.rewardPercent}%</span>
        </div>
        <div className="row">
          <span className="font-bold">{t('staking-history.header.status')}</span>
          <span
            className={`${
              item.status === StakingStatus.CANCEL ? 'staking-cancel' : 'staking-progress'
            } font-bold`}
          >
            {item.status}
          </span>
        </div>
        <div className="row">
          <span className="font-bold ">{t('staking-history.header.stake-amount')}</span>
          <span className="font-bold">{formatAmountV2(item.stakeAmount, 2)} $TBET</span>
        </div>
        <div className="row">
          <span className="font-bold">{t('staking-history.header.next-claim-date')}</span>
          <span>{formatDateNoTime(item.claimDate)}</span>
        </div>
        {item.claimHistory.length > 0 && (
          <>
            <div className="row">
              <span className="font-bold">{t('staking-history.header.claim-history')}</span>
            </div>
            <div className="claim-history">
              {item.claimHistory.map((row) => (
                <div className="claim-history-item">
                  <div className="row">
                    <span className="font-bold">{t('staking-history.header.claim-amount')}</span>
                    <span className="staking-progress font-bold">
                      +{formatAmountV2(row.claimAmount, 2)} $TBET
                    </span>
                  </div>
                  <div className="row">
                    <span className="font-bold">{t('staking-history.header.claim-date')}</span>
                    <span> {formatDateNoTime(row.claimDate)}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ClaimHistoryModal;
